var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1579 0.666748H1.73684C0.964907 0.666748 0.333328 1.31448 0.333328 2.10614V12.1819H1.73684V2.10614H10.1579V0.666748ZM12.2632 3.54554H4.54385C3.77192 3.54554 3.14035 4.19326 3.14035 4.98493V15.0607C3.14035 15.8524 3.77192 16.5001 4.54385 16.5001H12.2632C13.0351 16.5001 13.6667 15.8524 13.6667 15.0607V4.98493C13.6667 4.19326 13.0351 3.54554 12.2632 3.54554ZM12.2632 15.0607H4.54385V4.98493H12.2632V15.0607Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.87ef57c1c503c04f800cc4084c1f235d.svg";
export { ForwardRef as ReactComponent };